<script>
import { roundOff, numberWithCommas } from "@/utils";
import moment from "moment";
export default {
  name: "heatmap-table",
  props: ["cohort_data", "dtpicker"],
  data: function() {
    return {
      items: [],
      items2: [],
      cohortData: []
    };
  },
  mounted() {
    // console.log("Heatmap component mounted...");
    // console.log("this.cohort_data", this.cohort_data);
    this.cohortData = this.cohort_data ? this.cohort_data : [];
    setTimeout(() => this.getCohortData(), 2000);
  },
  computed: {
    series() {
      let rows = this.setItems();
      let items = this.items;
      let data = [];
      for (let i = 0; i < rows.length; i++) {
        let row = rows[i];
        let item = items[i] ? items[i] : null;
        let series = this.setSeries(row, item);
        let dataObj = {};
        dataObj.data = [];
        series.forEach(v => {
          dataObj.data.push(v);
        });
        data.push(JSON.parse(JSON.stringify(dataObj)));
      }
      // console.log(data);
      return data;
    }
  },
  methods: {
    setSeries(cohort, items) {
      let data = [];
      data.push({
        label: true,
        value: cohort.name
      });
      data.push({
        label: true,
        value: cohort.value
      });
      if (items) {
        let keys = Object.keys(items);
        keys.forEach(key => {
          data.push({
            label: false,
            value: items[key]
          });
        });
      } else {
        for (let i = 0; i < 12; i++) {
          data.push({
            label: false,
            value: 0
          });
        }
      }
      return data;
    },
    formatValue(item) {
      let value = item.value ? item.value : 0;
      if (!item.label) {
        value = parseFloat(value) * 100;
        value = roundOff(value);
        value = parseFloat(value) + "%";
      } else {
        // console.log("value", value);
        if (!isNaN(value)) {
          value = numberWithCommas(value);
        }
      }
      return value;
    },
    opacity(item) {
      let value = item.value ? item.value : 0;
      if (!item.label) {
        // value = parseFloat(value) * 100;
        value = roundOff(value);
        value = parseFloat(value);
      }
      // console.log(value);
      return value;
    },
    background(item, label) {
      // console.log("label", label);
      if (!label) {
        let opacity = this.opacity(item);
        let color = "#ffffff";
        if (opacity < 1) {
          color = "#999999";
        }
        return {
          background: `rgba(88, 102, 219, ${opacity})`,
          color: `${color}`
        };
      }
    },
    getCohortData() {
      // console.log(this.cohortData);
      let data = this.cohortData;
      this.items = data && data.retention_matrix ? data.retention_matrix : [];
      this.setData();
      // console.log("this.items", this.items);
    },
    setData() {
      let data = this.cohortData;
      // console.log("data", data);
      this.items2 = data && data.cohort_size ? data.cohort_size : [];
      // console.log(this.items2);
    },
    setItemsTotal() {
      let items = this.items2;
      let total = 0;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        total = total + item.cohort_size;
      }
      // return {
      //   name: "Total",
      //   value: total
      // };
      return numberWithCommas(total);
    },
    setItems() {
      let currentDate = moment(this.dtpicker.start).format("YYYY-MM-01");
      let tempDate = currentDate;
      let items = this.items2;
      let data = [];
      // data.push(this.setItemsTotal());
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let keys = Object.keys(item);
        let dataObj = {};
        keys.forEach(key => {
          dataObj.name = moment(tempDate).format("MMM YYYY");
          dataObj.value = item[key];
          data.push(dataObj);
        });
        tempDate = moment(tempDate).add(1, "M");
      }
      // console.log(data[1]);
      return data;
    }
  }
};
</script>

<template>
  <div class="mr-5">
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Month</th>
            <th>Customers</th>
            <th v-for="(item, index) in items" :key="index">M{{ index }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total</td>
            <td>{{ setItemsTotal() }}</td>
          </tr>
          <tr v-for="(item, index) in series" :key="index">
            <td
              v-for="(data, indexx) in item.data"
              :key="indexx"
              :style="background(data, data.label)"
            >
              {{ formatValue(data) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
